export enum AddressFields {
  CITY = 'city',
  COUNTRY = 'country',
  LINE1 = 'line1',
  LINE2 = 'line2',
  NAME = 'name',
  STATE = 'state',
  ZIP = 'zip',
}

export enum AddressAttachedToType {
  CONTACT_GROUP = 'contact_group',
}
